var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"glyphicon glyphicon-info-sign",attrs:{"data-toggle":"tooltip","data-html":"true","title":_vm.description}})
}
var staticRenderFns = []

export { render, staticRenderFns }